import React, { useEffect } from 'react';
import {
  getNotificationPermission,
  requestFCMToken,
  getExistingFCMToken,
  isNotificationSupported,
  needsExplicitPermissionUi,
  saveTokenToBackend,
  setupTokenRefresh
} from '../../push/firebaseUtils';

/**
 * Desktop (non-Safari/iOS): auto-request permission on load when still default (footyleague pattern).
 */
const NotificationPermission = ({ onTokenReceived }) => {
  useEffect(() => {
    const run = async () => {
      if (!isNotificationSupported()) {
        return;
      }
      const permission = getNotificationPermission();
      if (permission === 'granted') {
        const token = await getExistingFCMToken();
        if (token) {
          try {
            await saveTokenToBackend(token);
            setupTokenRefresh(onTokenReceived);
            onTokenReceived && onTokenReceived(token);
          } catch (error) {
            console.error('[push] Failed to save existing token:', error);
          }
        }
        return;
      }
      if (permission === 'default' && !needsExplicitPermissionUi()) {
        try {
          const token = await requestFCMToken();
          await saveTokenToBackend(token);
          setupTokenRefresh(onTokenReceived);
          onTokenReceived && onTokenReceived(token);
        } catch (error) {
          console.error('[push] Auto permission request failed:', error);
        }
      }
    };
    run();
  }, [onTokenReceived]);

  return null;
};

export default NotificationPermission;
